import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ success }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(success ? "checking" : "cancel");

  useEffect(() => {
    if (!success) return;
    const sid = new URLSearchParams(location.search).get("session_id");
    if (!sid) return setStatus("error");
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (data.status === "failed") return setStatus("error");
      } catch (e) {}
      if (tries++ < 8) setTimeout(poll, 2000);
      else setStatus("error");
    };
    poll();
  }, [success, location.search]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-10 text-center" data-testid="payment-result">
        {status === "checking" && <><Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold">Confirming payment…</h1></>}
        {status === "paid" && <><CheckCircle2 className="w-14 h-14 text-primary mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold mb-2">Subscription active!</h1><p className="text-muted-foreground text-sm mb-6">You can now submit your listing for shop approval.</p></>}
        {(status === "cancel" || status === "error") && <><XCircle className="w-14 h-14 text-destructive mx-auto mb-4" /><h1 className="font-heading text-2xl font-bold mb-2">{status === "cancel" ? "Payment cancelled" : "Something went wrong"}</h1><p className="text-muted-foreground text-sm mb-6">No charge was made. You can try again anytime.</p></>}
        {status !== "checking" && <Button onClick={() => navigate("/advertiser")} data-testid="payment-result-back" className="w-full">Back to dashboard</Button>}
      </div>
    </div>
  );
}
